import { Col, Icon, MediaModal, Row, Text } from 'components';
import { theme } from 'lib';
import { useEffect, useState } from 'react';
import styled from 'styled-components';

const ImageBackground = styled.div`
  width: 72px;
  height: 97px;
  display: flex;
  background-image: url(${(props) => props.src});
  background-position: center;
  background-size: contain;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  background-color: #000;
`;

const NormalText = styled.span`
  font-weight: 400;
`;
const videoFileTypes = [
  'mp4',
  'mov',
  'avi',
  'mkv',
  'video/mp4',
  'video/mov',
  'video/avi',
  'video/mkv'
];
const CustomShoutout = ({ video, data, user }) => {
  const [preview, setPreview] = useState(null);

  // Check for the first available media preview
  const firstMedia =
    (data.media?.length && data.media[0].preview) ||
    data.metaData?.image ||
    (data.youtubeId && `https://img.youtube.com/vi/${data.youtubeId}/0.jpg`);

  const isVideo = (file) => {
    if (!file) return false;
    const fileType = file?.type || file?.name?.split('.').pop().toLowerCase();
    return videoFileTypes.includes(fileType);
  };

  useEffect(() => {
    if (firstMedia) {
      // If firstMedia is available, set it as the preview (image preview)
      setPreview(firstMedia);
    } else {
      if (!video) return setPreview(null);

      // If no firstMedia, set video preview
      setPreview(URL.createObjectURL(video.file));
    }
  }, [firstMedia, video]);

  return (
    <Row pad="16px" bg={theme.GREY_10} wid="264px" ht="97px">
      {preview && (
        <Col pos="relative" wid="72px" ht="97px" noFlex marg="0 12px 0 0">
          {/* Show image preview if it's available, or show video preview */}
          <MediaModal media={preview} forceVideo={isVideo(video?.file)}>
            <ImageBackground src={preview}>
              {/* Show play button only if the media is a video */}
              {isVideo(video?.file) && (
                <Col
                  zIndex="1"
                  bg="rgba(210, 216, 223, 0.7)"
                  center
                  noFlex
                  wid="32px"
                  ht="32px"
                  hasRadius="32px"
                  centerAll
                >
                  <Icon type="playOutline" dimensions={14} />
                </Col>
              )}
            </ImageBackground>
          </MediaModal>
        </Col>
      )}

      <Col noFlex>
        <Row maxWid={video ? '180px' : '100%'}>
          <Text b2 bold wid={!video ? '264px' : '176px'}>
            {data.entity?.username ? data.entity.username + ' ' : ''}
            <NormalText>from </NormalText>
            {user?.username}
          </Text>
        </Row>

        <Text marg="4px 0 0">{data.comment}</Text>
      </Col>
    </Row>
  );
};

export default CustomShoutout;
